<app-nav-cliente></app-nav-cliente>

<div class="container-fluid">
    <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-7">

            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" id="home-tab" data-toggle="tab" href="#paquetesTab" role="tab" aria-controls="paquetes-tab" aria-selected="true">Paquetes</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="profile-tab" data-toggle="tab" href="#placasTab" role="tab" aria-controls="placas-tab" aria-selected="false">Placas</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="messages-tab" data-toggle="tab" href="#marcosTab" role="tab" aria-controls="marcos-tab" aria-selected="false">Marcos</a>
                </li>

                <!-- <li class="nav-item">
                    <a class="nav-link" id="messages-tab" data-toggle="tab" href="#fondosMarcosTab" role="tab" aria-controls="fondosmarcos-tab" aria-selected="false">Fondos Marcos</a>
                  </li> -->

                <li class="nav-item">
                  <a class="nav-link" id="settings-tab" data-toggle="tab" href="#coloresTab" role="tab" aria-controls="colores-tab" aria-selected="false">Colores</a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" id="settings-tab" data-toggle="tab" href="#viajesTab" role="tab" aria-controls="viajes-tab" aria-selected="false">Viajes</a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" id="settings-tab" data-toggle="tab" href="#fiestaTab" role="tab" aria-controls="fiesta-tab" aria-selected="false">Fiesta</a>
                </li>
  
                <li class="nav-item">
                    <a class="nav-link" id="settings-tab" data-toggle="tab" href="#anillosTab" role="tab" aria-controls="anillos-tab" aria-selected="false">Anillos</a>
                </li>

                <!-- <li class="nav-item">
                    <a class="nav-link" id="settings-tab" data-toggle="tab" href="#productosTab" role="tab" aria-controls="productos-tab" aria-selected="false">Productos Extra</a>
                </li> -->

                <li class="nav-item">
                    <a class="nav-link" id="settings-tab" data-toggle="tab" href="#dedicatoriasTab" role="tab" aria-controls="dedicatorias-tab" aria-selected="false">Dedicatorias</a>
                </li>

              </ul>
              
              <div class="tab-content">
                <div class="tab-pane active" id="paquetesTab" role="tabpanel" aria-labelledby="paquetes-tab">
                    <br>
                    <div class="row">
                        <div class="col-lg-3 col-sm-3 col-md-3 col-6" *ngFor="let paquete of paquetesToChoose">
                            <div *ngIf="paquete.imagen; else imagenAuri">
                                <img src="{{environment}}{{paquete.imagen}}" width="100%">
                            </div>
                            <ng-template #imagenAuri>
                                <img src="assets/img/auri.png" width="100%"><br>
                            </ng-template>
                            <p class="center">{{paquete.nombre}}
                                <br><strong>${{paquete.precio}}</strong><br>
                                <span (click)="getDetallePaquete(paquete.id)">Ver Detalles</span>
                            </p>
                            <div *ngIf="solicitado==0">
                                <button class="fondoAmarillo border0 input90" (click)="agregarPaqueteCliente(paquete.id, clienteid)">Agregar Paquete</button><br><br>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-pane" id="placasTab" role="tabpanel" aria-labelledby="placas-tab">
                    <br>
                    <div class="row">
                        <div *ngFor="let placa of placas" class="col-lg-3 col-sm-3 col-md-3 col-6">
                            <div *ngIf="placa.imagen; else imagenAuri2">
                                <img src="{{environment}}{{placa.imagen}}" width="100%"><br>
                            </div>
                            <ng-template #imagenAuri2>
                                <img src="assets/img/auri.png" width="100%"><br>
                            </ng-template>

                            <p class="center">{{placa.nombre}}</p>
                            <div *ngIf="solicitado==0">
                                <button class="fondoAmarillo border0 input90" (click)="agregarPlaca(placa.id, clienteid)">Elegir Placa</button><br><br>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="tab-pane" id="marcosTab" role="tabpanel" aria-labelledby="marcos-tab">
                    <br>
                    <div class="row">
                    <div *ngFor="let moldura of molduras" class="col-lg-3 col-sm-3 col-md-3 col-6">
                        <div *ngIf="moldura.imagen; else imagenAuri4">
                            <img src="{{environment}}{{moldura.imagen}}" width="100%">
                        </div>
                        <ng-template #imagenAuri4>
                            <img src="assets/img/auri.png" width="100%"><br>
                        </ng-template>

                        <p class="center">{{moldura.nombre}}</p>
                        <div *ngIf="solicitado==0">
                            <button class="fondoAmarillo border0 input90" (click)="agregarMoldura(moldura.id, clienteid)">Elegir Marco</button><br><br>
                        </div>
                    </div>
                    </div>
                </div>

                <div class="tab-pane" id="fondosMarcosTab" role="tabpanel" aria-labelledby="fondosmarcos-tab">
                    <br>
                    <div class="row">
                    <div *ngFor="let fondoMarco of fondosMarcos" class="col-lg-3 col-sm-3 col-md-3 col-6">
                        <div *ngIf="fondoMarco.imagen; else imagenAuri5">
                            <img src="{{environment}}{{fondoMarco.imagen}}" width="100%">
                        </div>
                        <ng-template #imagenAuri5>
                            <img src="assets/img/auri.png" width="100%"><br>
                        </ng-template>

                        <p class="center">{{fondoMarco.nombre}}</p>
                        <div *ngIf="solicitado==0">
                            <button class="fondoAmarillo border0 input90" (click)="agregarFondoMolduraCliente(fondoMarco.id, clienteid)">Elegir Marco</button><br><br>
                        </div>
                    </div>
                    </div>
                </div>

                <div class="tab-pane" id="coloresTab" role="tabpanel" aria-labelledby="colores-tab">
                    <br>
                    <div class="row">
                        <br>
                        <div *ngFor="let color of colores" class="col-lg-3 col-sm-3 col-md-3 col-6">
                            <div *ngIf="color.imagen; else imagenAuri3">
                                <img src="{{environment}}{{color.imagen}}" width="100%">
                            </div>
                            <ng-template #imagenAuri3>
                                <img src="assets/img/auri.png" width="100%"><br>
                            </ng-template>

                            <p class="center">{{color.nombre}}</p>
                            <div *ngIf="solicitado==0">
                                <button class="fondoAmarillo border0 input90" (click)="agregarColor(color.id, clienteid)">Elegir Color</button><br><br>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane" id="viajesTab" role="tabpanel" aria-labelledby="viajes-tab">
                    <br>
                    <div class="row" *ngFor="let viaje of viajes">
                        <div  class="col-lg-3 col-sm-3 col-md-4 col-6">
                            <img src="{{environment}}{{viaje.imagen}}" width="100%"><br>
                            <br>
                            
                           
                        </div>
                        <div class="col-lg-6 col-sm-3 col-md-8 col-6">
                            <h5 class="center">{{viaje.nombre}}</h5>
                            <p class="center">{{viaje.descripcion}}<br>
                            <span class="bold">${{viaje.precio}}</span></p>
                            <div *ngIf="solicitado==0">
                                <button class="fondoAmarillo border0 input90" (click)="agregarViaje(viaje.id, clienteid)">Agregar Viaje</button><br><br>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane" id="fiestaTab" role="tabpanel" aria-labelledby="fiesta-tab">
                    <br>
                    <div class="row" *ngFor="let fiesta of fiestas;  index as i;">
                        <div  class="col-lg-3 col-sm-3 col-md-4 col-6">
                            <img src="{{environment}}{{fiesta.imagen}}" width="100%"><br>
                            <br>
                           
                        </div>
                        <div class="col-lg-6 col-sm-6 col-md-8 col-6">
                            <h5 class="center">{{fiesta.nombre}}</h5>
                            <p class="center">{{fiesta.descripcion}}<br>
                            
                            <span class="bold">Boleto Adulto: ${{fiesta.precio}}</span><br>
                            <span class="bold">Boleto Niño: ${{fiesta.precio_nino}}</span></p>
                            <!-- <div *ngIf="solicitado==0"> -->
                                <p class="center">
                                    Boletos Adulto:
                                    <input type="text" size="4" [(ngModel)]="boletos_adulto[i]" placeholder="10"> 
                                    <button class="fondoAmarillo border0 negro" (click)="agregarBoletosAdulto(clienteid, fiesta.id, i);"> Agregar</button>   
                                </p>
                                
                                <p class="center">
                                    Boletos Niño:
                                    <input type="text" size="4" [(ngModel)]="boletos_nino[i]" placeholder="10"> 
                                    <button class="fondoAmarillo border0 negro" (click)="agregarBoletosNino(clienteid, fiesta.id, i);"> Agregar</button>   
                                </p>
                            <!-- </div> -->
                        </div>
                    </div>
                </div>
                <div class="tab-pane" id="anillosTab" role="tabpanel" aria-labelledby="anillos-tab">
                    <br>
                    <div class="row">
                        <div *ngFor="let anillo of anillos; let positionModeloAnillo=index" class="col-lg-3 col-sm-3 col-md-3 col-6">
                            <img src="{{environment}}{{anillo.imagen}}" width="100%"><br>
                            <p class="center">{{anillo.nombre}} <br>
                                <select [(ngModel)]="preciosAnilloIds[positionModeloAnillo]" (change)="selectAnillo(preciosAnilloIds[positionModeloAnillo])" style="width: 100%;">
                                    <option value="0" selected>Selecciona tipo de anillo</option>
                                    <option *ngFor="let precioAnillo of precioAnillos; let position=index" [value]="precioAnillo.id">{{precioAnillo.metal}} 
                                        {{precioAnillo.gramaje}} {{precioAnillo.precio | currency}}</option>
                                </select>
                                <br>
                                <select  [(ngModel)]="medidaAnillos[positionModeloAnillo]" style="width: 100%;">
                                    <option value="0" selected>Selecciona medida de anillo</option>
                                    <option value="2">2</option>
                                    <option value="2.5" >2.5</option>
                                    <option value="3" >3</option>
                                    <option value="3.5" >3.5</option>
                                    <option value="4" >4</option>
                                    <option value="4.5" >4.5</option>
                                    <option value="5" >5</option>
                                    <option value="5.5" >5.5</option>
                                    <option value="6" >6</option>
                                    <option value="6.5" >6.5</option>
                                    <option value="7" >7</option>
                                    <option value="7.5" >7.5</option>
                                    <option value="8" >8</option>
                                    <option value="8.5" >8.5</option>
                                    <option value="9" >9</option>
                                    <option value="9.5" >9.5</option>
                                    <option value="10" >10</option>
                                    <option value="10.5" >10.5</option>
                                    <option value="11" >11</option>
                                    <option value="11.5" >11.5</option>
                                    <option value="12" >12</option>
                                    <option value="12.5" >12.5</option>
                                    <option value="13" >13</option>
                                    <option value="13.5" >13.5</option>
                                    <option value="14" >14</option>
                                </select>
                            <div *ngIf="solicitado==0">
                                <!-- <button class="fondoAmarillo border0 input90" (click)="agregarAnilloCliente(anillo.id, clienteid, preciosAnilloIds[positionModeloAnillo], medidaAnillos[positionModeloAnillo])">Elegir Anillo</button><br><br> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-pane" id="productosTab" role="tabpanel" aria-labelledby="productos-tab">
                    <br>
                    <div class="row">
                        <div *ngFor="let producto of productos" class="col-lg-3 col-sm-3 col-md-3 col-6">
                            <div *ngIf="producto.imagen; else imagenAuri5">
                                <img src="{{environment}}{{producto.imagen}}" width="100%">
                            </div>
                            <ng-template #imagenAuri5>
                                <img src="assets/img/auri.png" width="100%"><br>
                            </ng-template>
    
                            <p class="center">{{producto.nombre}}
                            <br><strong>${{producto.precio}}</strong><br></p>
    
                            <div *ngIf="solicitado==0">
                                <button class="fondoAmarillo border0 input90" (click)="agregarProductoCliente(producto.id, clienteid)">Elegir Producto</button><br><br>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="tab-pane" id="dedicatoriasTab" role="tabpanel" aria-labelledby="dedicatorias-tab">
                    <br>
                    <p>Dedicatoria Personalizada:</p>
                    <span>Dirigiado a  (50 Caracteres máximo):</span><br>
                    <input type="text" [(ngModel)]="dedicatoriaPersonalizada.dirigido" maxlength="50" class="form-control"><br><br>
                    <textarea class="form-control" placeholder="Escribir Dedicatoria... (300 Caracteres Máximo)" maxlength="300" [(ngModel)]="dedicatoriaPersonalizada.texto"></textarea><br>
                    <div class="row">
                        <div class="col-lg-4">
                            <button class="fondoAmarillo border0 input90" (click)="agregarDedicatoriaCliente('Personalizada', dedicatoriaPersonalizada.texto, dedicatoriaPersonalizada.dirigido, clienteid)">Agregar Dedicatoria</button><br><br><br>
                        </div>
                        <div class="col-lg-3"></div>
                        <div class="col-lg-3"></div>
                    </div>
    
                    <div class="row">
                        <div *ngFor="let dedicatoria of dedicatorias; let positionDedicatoriaAnillo=index" class="col-lg-3 col-sm-3 col-md-3 col-6">
                           
                            <p class="center"><strong>{{dedicatoria.nombre}}</strong>
                            <br>{{dedicatoria.texto}}<br></p>
                            <div *ngIf="solicitado==0">
                                <button class="fondoAmarillo border0 input90" (click)="agregarDedicatoriaCliente(dedicatoria.nombre, dedicatoria.texto, dedicatoriaPersonalizada.dirigido, clienteid)">Elegir Dedicatoria</button><br><br>
                            </div>
                        </div>
                    </div>
                </div>

              </div>

              

            <!-- <div id="accordion">
                <div class="card">
                    <div class="card-header bg-warning" id="headingOne">
                        <h5 class="mb-0">
                        <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            <strong class="negro">Paquetes</strong>
                        </button>
                        </h5>
                    </div>
                                
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-3" *ngFor="let paquete of paquetesToChoose">
                                    <div *ngIf="paquete.imagen; else imagenAuri">
                                        <img src="{{environment}}{{paquete.imagen}}" width="100%">
                                    </div>
                                    <ng-template #imagenAuri>
                                        <img src="assets/img/auri.png" width="100%"><br>
                                    </ng-template>
                                    <p class="center">{{paquete.nombre}}
                                        <br><strong>${{paquete.precio}}</strong><br>
                                        <span (click)="getDetallePaquete(paquete.id)">Ver Detalles</span>
                                    </p>
                                    <div *ngIf="solicitado==0">
                                        <button class="fondoAmarillo border0 input90" (click)="agregarPaqueteCliente(paquete.id, clienteid)">Agregar Paquete</button><br><br>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="card">
                    <div class="card-header bg-warning" id="headingTwo">
                    <h5 class="mb-0">
                        <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            <strong class="negro">Placas</strong>
                        </button>
                    </h5>
                    </div>
                    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row">
                            <div *ngFor="let placa of placas" class="col-lg-3">
                                <img src="{{environment}}{{placa.imagen}}" width="100%"><br>
                                <p class="center">{{placa.nombre}}</p>
                                <div *ngIf="solicitado==0">
                                    <button class="fondoAmarillo border0 input90" (click)="agregarPlaca(placa.id, clienteid)">Elegir Placa</button><br><br>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header bg-warning" id="headingFive">
                        <h5 class="mb-0">
                            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseThree">
                            <strong class="negro">Marcos</strong>
                            </button>
                        </h5>
                    </div>
                    <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row">
                            <div *ngFor="let moldura of molduras" class="col-lg-3">
                                <img src="{{environment}}{{moldura.imagen}}" width="100%"><br>
                                <p class="center">{{moldura.nombre}}</p>
                                <div *ngIf="solicitado==0">
                                    <button class="fondoAmarillo border0 input90" (click)="agregarMoldura(moldura.id, clienteid)">Elegir Marco</button><br><br>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>


                <div class="card">
                    <div class="card-header bg-warning" id="headingThree">
                        <h5 class="mb-0">
                            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            <strong class="negro">Colores</strong>
                            </button>
                        </h5>
                    </div>
                    <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row">
                            <div *ngFor="let color of colores" class="col-lg-3">
                                <img src="{{environment}}{{color.imagen}}" width="100%"><br>
                                <p class="center">{{color.nombre}}</p>
                                <div *ngIf="solicitado==0">
                                    <button class="fondoAmarillo border0 input90" (click)="agregarColor(color.id, clienteid)">Elegir Color</button><br><br>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header bg-warning" id="headingFour">
                        <h5 class="mb-0">
                            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseThree">
                            <strong class="negro">Viajes</strong>
                            </button>
                        </h5>
                    </div>
                    <div id="collapseFour" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row" *ngFor="let viaje of viajes">
                            <div  class="col-lg-3">
                                <img src="{{environment}}{{viaje.imagen}}" width="100%"><br>
                                
                               
                            </div>
                            <div class="col-lg-6">
                                <h5 class="center">{{viaje.nombre}}</h5>
                                <p class="center">{{viaje.descripcion}}<br>
                                <span class="bold">${{viaje.precio}}</span></p>
                                <div *ngIf="solicitado==0">
                                    <button class="fondoAmarillo border0 input90" (click)="agregarViaje(viaje.id, clienteid)">Agregar Viaje</button><br><br>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>


                <div class="card">
                    <div class="card-header bg-warning" id="headingSix">
                        <h5 class="mb-0">
                            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                            <strong class="negro">Fiestas</strong>
                            </button>
                        </h5>
                    </div>
                    <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row" *ngFor="let fiesta of fiestas">
                            <div  class="col-lg-3">
                                <img src="{{environment}}{{fiesta.imagen}}" width="100%"><br>
                                
                               
                            </div>
                            <div class="col-lg-6">
                                <h5 class="center">{{fiesta.nombre}}</h5>
                                <p class="center">{{fiesta.descripcion}}<br>
                                
                                <span class="bold">Boleto Adulto: ${{fiesta.precio}}</span><br>
                                <span class="bold">Boleto Niño: ${{fiesta.precio_nino}}</span></p>
                                <p class="center">
                                    Boletos Adulto:
                                    <input type="text" size="4" [(ngModel)]="boletos.adulto" placeholder="10"> 
                                    <button class="fondoAmarillo border0 negro" (click)="agregarBoletosAdulto(clienteid, fiesta.id);"> Agregar</button>   
                                </p>

                                <p class="center">
                                    Boletos Niño:
                                    <input type="text" size="4" [(ngModel)]="boletos.nino" placeholder="10"> 
                                    <button class="fondoAmarillo border0 negro" (click)="agregarBoletosNino(clienteid, fiesta.id);"> Agregar</button>   
                                </p>
                               
                            </div>
                        </div>
                        </div>
                    </div>
                </div>


                <div class="card">
                    <div class="card-header bg-warning" id="headingSeven">
                        <h5 class="mb-0">
                            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                            <strong class="negro">Anillos</strong>
                            </button>
                        </h5>
                    </div>
                    <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row">
                            <div *ngFor="let anillo of anillos" class="col-lg-3">
                                <img src="{{environment}}{{anillo.imagen}}" width="100%"><br>
                                <p class="center">{{anillo.nombre}} | {{anillo.metal}} {{anillo.gramaje}}<br>
                                    <span class="bold">${{anillo.precio}}</span></p>
                                <div *ngIf="solicitado==0">
                                    <button class="fondoAmarillo border0 input90" (click)="agregarAnilloCliente(anillo.id, clienteid)">Elegir Anillo</button><br><br>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>

            </div>              -->
        </div>
        <div class="col-lg-3">
            <app-mi-paquete></app-mi-paquete>
        </div>
        <div class="col-lg-1"></div>            
    </div>
</div>



<div id="clickPaquete" (click)="openModal(mymodal2)"></div>
<ng-template #mymodal2 let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{nombrePaquete}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="dismissAll()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">
        <p>{{descripcion}}</p>

        <h5>Incluye:</h5>
        <img src="{{environment}}{{paqueteImagen}}" width="300px">
        <ul>
            <li *ngFor="let producto of detallePaquete">{{producto.nombre}}</li>
        </ul>
        
        <button class="btn btn-warning" (click)="agregarPaqueteCliente(paqueteid, clienteid)">Agregar</button>

    </div>
    <div class="modal-footer">
       

    </div>
  </ng-template>